import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './Minigames.scss';
import Box from '../../../components/Box/Box';
import { useEffect, useState } from 'react';
import api from '../../../js/api';

export default function Rooms() {

    const s_params = useSearchParams();
    const navigate = useNavigate();
    const [rooms, setRooms] = useState(null);
    const { gameName } = useParams();

    useEffect(() => {
        if (!gameName) {
            navigate('/misc/minigames', { replace: true });
            return;
        }

        const login = s_params[0].get('login');

        let path = `/games/${gameName}/rooms`;
        if (login) {
            path = `/users/${login}/rooms`;
        }

        api.get(path).then((res) => {
            if (res && res.error) {
                console.error('Error fetching rooms:', res.error);
                navigate('/misc/minigames', { replace: true });
                return;
            }
            console.log('path used:', path);
            console.log('Fetched rooms:', res);
            setRooms(res);
        }).catch((error) => {
            console.error('Error fetching rooms:', error);
            navigate('/misc/minigames', { replace: true });
        });
    }, []);

    if (!rooms) {
        return (
            <div className="rooms">
                <div className="centered-container">
                    <h2>Game: {gameName}</h2>
                    <br />
                    <h1>Rooms</h1>
                    <p>Loading rooms...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="rooms">
            <div className="centered-container">
                <h2>Game: {gameName}</h2>
                <br />
                <h1>Rooms</h1>
                
                <div className="rooms-list">
                    {rooms?.filter(room => room && room.id && room.game && room.game.toLowerCase() === gameName.toLowerCase()).map((room, index) => (
                        <div key={index} className="room">
                            <Box title={`Room code: ${room.id}`} url={`/misc/minigames/${gameName}/rooms/${room.id}`}>
                                <p>Name: {room.name}</p>
                                <p>Admin: {room.admin}</p>
                                <p>Game: {room.game}</p>
                                <p>Private: {room.is_private ? 'Yes' : 'No'}</p>
                                <p>Created at: {room.created_at}</p>
                            </Box>
                        </div>
                    ))}
                </div>
                    
            </div>
        </div>
    );
}